module.exports = __webpack_public_path__ + "static/media/storieTwo.41c13e68.jpg";